document.addEventListener('DOMContentLoaded', function() {
  const customHeader = document.querySelector('.custom-navigation');
  const showThis = document.querySelector('.quick-links-section');
  if (!customHeader) {
    if(showThis){
      showThis.classList.add('active');
    }
  }
   // Sticky Header
  const mainHeader = document.querySelector('.shopify-section-header-sticky');
  const universalHeader = document.querySelector('.universal-header.custom-header');
  if (universalHeader && mainHeader){
    mainHeader.classList.add('universal-stuck');
  }
});